import { lazy } from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import { AppShell } from "./layout/AppShell";
import { Overview } from "./pages/Overview";
import { Login } from "./pages/Login";

// Everything past the landing page is code-split — the heavy report grid (ReportTable/PivotTable)
// and Settings only download when first opened. AppShell wraps <Outlet /> in <Suspense>.
const Report = lazy(() => import("./pages/Report").then((m) => ({ default: m.Report })));
const AllReports = lazy(() => import("./pages/AllReports").then((m) => ({ default: m.AllReports })));
const ProductDetail = lazy(() => import("./pages/ProductDetail").then((m) => ({ default: m.ProductDetail })));
const Reconciliation = lazy(() => import("./pages/Reconciliation").then((m) => ({ default: m.Reconciliation })));
const Alerts = lazy(() => import("./pages/Alerts").then((m) => ({ default: m.Alerts })));
const Settings = lazy(() => import("./pages/Settings").then((m) => ({ default: m.Settings })));

export const router = createBrowserRouter([
  { path: "/login", element: <Login /> },
  {
    path: "/",
    element: <AppShell />,
    children: [
      { index: true, element: <Overview /> },
      { path: "report/:key", element: <Report /> },
      { path: "all-reports", element: <AllReports /> },
      { path: "product/:id", element: <ProductDetail /> },
      { path: "reconciliation", element: <Reconciliation /> },
      { path: "alerts", element: <Alerts /> },
      { path: "settings", element: <Settings /> },
      // legacy
      { path: "dashboard", element: <Navigate to="/" replace /> },
      { path: "products", element: <Navigate to="/report/current" replace /> },
      { path: "warehouse", element: <Navigate to="/report/current" replace /> },
      { path: "analytics", element: <Navigate to="/report/daily" replace /> },
    ],
  },
]);
